import styled from 'styled-components'
import { motion } from 'framer-motion'
export const StyledLink = styled(motion.button)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 12.5rem;
    border: none;
    font-size: 1.4em;
    background-color: ${({ level }) => level.bg};
    cursor: pointer;
    position: relative;
    &:hover {
      filter: brightness(0.9);
    }
    text-decoration: none;
    > span {

      color: #fdfdfd;
      flex: 1;
      text-align: left;
      height: 100%;
      padding: 1rem;
      word-break: anywhere;
    }
    svg {
      opacity: 0;
      margin-right: -1em
    }
    &.completed {
      svg {
        opacity: 1;
        position: relative;
        z-index: 500;
        path {
          transform: translateX(-5em);
        }
        filter: drop-shadow(2px 2px 2px #3d3d3d);
      }
      &:after {
        content: '';
        position:absolute;
        width: 100%;
        height: 100%;
        z-index:200;
        background: hsla(0, 10%, 29%, 1);
        opacity: 0.5;
      }
    }
`
export const CompletedIndicator = styled.div`
  position: relative;
  margin-right: -1rem;
  margin-top: -0.5rem;
`

export const MenuContentWrapper = styled.div`
  align-self: center;
  flex:1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 1200px;
`

export const LevelsContainer = styled(motion.div)`
  width: 100%;
  display: grid;
  align-self: center;
  grid-gap: 1.5rem;
  grid-template-columns: 1fr;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  padding: 1.5rem;
`

export const LevelMenuTitle = styled.h1`
  > span {
    color: #fdfdfd;
  }
  font-size: 3.5em;
  text-align: left;
  font-weight: 300;
  margin: 1.5rem;
`
